import React from 'react';
import { extend } from '@thd-nucleus/data-sources';
import {
  PodSection,
  PodSpacer,
  ProductPod,
  ProductImage,
  ProductIdentifier,
} from '@thd-olt-component-react/product-pod';
import {
  bool as boolType,
  string as stringType,
  number as numType
} from 'prop-types';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { Price } from '@thd-olt-component-react/price';
import { SuperSkuMiniSwatches } from '@thd-olt-component-react/super-sku';

export const DiscoveryZonesPod = (props) => {
  const {
    // eslint-disable-next-line react/prop-types
    itemId,
    storeId,
    position,
    parent,
    scheme,
    anchorProduct,
    preferredPriceFlag,
    brandTitleMaxLine,
    zoneName,
    zonePosition,
    podResults,
  } = props;

  return (
    <ProductPod
      itemId={itemId}
      storeId={storeId}
      analyticsData={{
        parent, position, scheme, anchorProduct, zoneName, zonePosition, podResults
      }}
      render={(pod) => (
        <>
          <ProductImage
            itemId={pod.itemId}
            showSecondaryImage={pod.showSecondaryImage}
            onClick={() => { }}
          />
          <PodSection columnAlign>
            <PodSpacer padding={['TOP', 'BOTTOM']}>
              <ProductHeader
                brand="above"
                itemId={pod.itemId}
                brandTitleMaxLine={brandTitleMaxLine}
                disableShopThisCollection
              />
            </PodSpacer>
            <Price
              itemId={pod.itemId}
              large={false}
              storeId={storeId}
              displayEachUom={false}
              hideSavingsText={!preferredPriceFlag}
              showPreferredPricingBadge
            />
          </PodSection>
        </>
      )}
    />
  );
};

DiscoveryZonesPod.dataModel = extend(
  ProductPod,
  ProductImage,
  ProductIdentifier,
  ProductHeader,
  SuperSkuMiniSwatches,
  Price,
);

DiscoveryZonesPod.propTypes = {
  storeId: stringType,
  position: numType,
  parent: stringType,
  scheme: stringType,
  anchorProduct: stringType,
  preferredPriceFlag: boolType,
  brandTitleMaxLine: numType,
  zoneName: stringType,
  zonePosition: stringType,
  podResults: numType,
};

DiscoveryZonesPod.defaultProps = {
  storeId: '',
  position: '',
  parent: '',
  scheme: 'drecs',
  anchorProduct: '',
  preferredPriceFlag: false,
  brandTitleMaxLine: 4,
  zoneName: '',
  zonePosition: '',
  podResults: 0,
};
DiscoveryZonesPod.displayName = 'DiscoveryZonesPod';
